import { Controller } from "@hotwired/stimulus"
import { animateCollapse } from '../helpers/animation_helpers'

export default class extends Controller {
  static targets = ['appendedCoupons']

  appendedCouponsTargetConnected(element) {
    animateCollapse(element, 0, element.offsetHeight, this.#findAnimationDuration(element))
  }

  #findAnimationDuration(element) {
    return element.offsetHeight / 2
  }
}
